import {
  getAllFlightsCitys,
  getAirportsByKeyword,
  getFlightCouponList,
  getFlightsBannerText,
} from '@/api/flights'
import { getPopList } from '@/pages/train-detail/components/privacy/api'
import {
  xenv,
  build,
  goTo,
  buildSearch,
  query as webxQuery,
  hashQuery
} from '@didi/webx-js'
import { getStorage } from '@/utils/storage'
import { FLIGHTS_URL_TYPES } from '@/common/enum'
import mpx from '@mpxjs/core'
import { serializeParams } from '@/utils'
import { handleFlightsCouponData } from '@/utils/flights-coupon'
import { locate, goto, is } from '@didi/spring-base'

import userStore from '../user'
import usexStore from '@/config/usex/lib/store'
import { addRavenPhoneAndUid } from '@/common/raven-init/init'
import { isALIMini, isWXMini } from '@/common/constant'

const query = () => {
  return {
    ...webxQuery(),
    ...hashQuery(),
  }
}

export default {
  getFlightsCityList({ state, commit }) {
    // 清空上次查询的数据 减少渲染时间
    commit('setSearchList')
    // 避免重复请求城市列表
    if(state.flightsCities.length || state.flightsHotCities.length) {
      return true
    }
    return getAllFlightsCitys().then(({ data, code }) => {
      if (code === 200) {
        commit('setAllFlightsCityList', { ...data })
        return true
      }else {
        return null
      }
    })
  },
  getFlightsCityListByKeyword({ commit }, payload) {
    return getAirportsByKeyword(payload).then(({ data, code }) => {
      if (code === 200) {
        const { airports = [], cityAirports = [] } = data
        commit('setSearchList', { airports, cityAirports })
        return airports.length + cityAirports.length
      }else {
        return null
      }
    })
  },
  // 查百川协议
  async initFlightsPrivacy({ state, commit }) {
    const SCENE = 'didijipiao'
    const CALLER = 'flights_home_to_tc'
    const appid = {
      alimp: 35023,
      wxmp: 35009,
      passenger: 10000,
      h5: 10000,
    }[xenv()]
    const token = getStorage('token') || getStorage('userInfo')?.token
    const ret = await getPopList({
      appid,
      token,
      scene_str: SCENE,
      caller: CALLER,
    })
    const {
      scene_map = {},
      doc_map = {},
    } = ret?.data || {}
    const privacyList = doc_map[scene_map[SCENE]] || {}
    commit('setPrivacyList', privacyList)
  },
  async checkPrivacyStatus({ state, commit, dispatch }) {
    return new Promise(async (resolve) => {
      // 检查登录
      if(!userStore.state.token && !userStore.state.userInfo?.token) {
        usexStore.dispatch('getToken', true).then((res) => {
          addRavenPhoneAndUid(res)
        })
        return
      }
      await dispatch('initFlightsPrivacy')
      if(!state.privacyList?.doc_id) {
        resolve()
      }else {
        commit('showPrivacyPopup', {
          cb: resolve
        })
      }
    })
  },
  async gotoFlightsPage({ state, getters }, payload = {}) {
    // 跳转类型 & 渠道数据
    const { type, sourceData } = payload
    // 查询主卡数据
    const { flightsQuery } = state
    const { selectDate, selectCitys } = getters
    // 机票url集合
    const TC_URL_MAP = {
      [FLIGHTS_URL_TYPES.ONE]: 'https://v.didi.cn/k6708pz',
      [FLIGHTS_URL_TYPES.SP_DETAIL]: 'https://v.didi.cn/k6708pz',
      [FLIGHTS_URL_TYPES.RT]: 'https://v.didi.cn/jR6Bpvz',
      [FLIGHTS_URL_TYPES.ORDER]: 'https://v.didi.cn/Lol3JGD',
      [FLIGHTS_URL_TYPES.GUIDEBOOK]: 'https://v.didi.cn/Lol3QQA',
    }
    const url = TC_URL_MAP[type]
    if(!url) return
    if([FLIGHTS_URL_TYPES.ONE, FLIGHTS_URL_TYPES.RT].includes(type) && selectCitys.fromCitys[0].city_id === selectCitys.toCitys[0].city_id) {
      mpx.showToast({
        title: '选择的出发到达城市不能相同哦~',
        icon: 'none',
      })
      return
    }
    let options = {}
    switch (type) {
      case FLIGHTS_URL_TYPES.RT:
        options = {
          backDate: selectDate.toDate, // 返程日期
        }
      case FLIGHTS_URL_TYPES.ONE:
        options = {
          ...options,
          // 单程 & 往返 公用参数
          date: selectDate.fromDate, // 出发日期
          // 出发
          fromCode: selectCitys.fromCitys[0].id,
          fromCity: selectCitys.fromCitys[0].name,
          fromcitycode: selectCitys.fromCitys[0].city_id,
          dcn: selectCitys.fromCitys[0].city_name,
          // 到达
          toCode: selectCitys.toCitys[0].id,
          toCity: selectCitys.toCitys[0].name,
          tocitycode: selectCitys.toCitys[0].city_id,
          acn: selectCitys.toCitys[0].city_name,
          // 舱位
          cabin: flightsQuery.cabin || 0,
        }
        break
      case FLIGHTS_URL_TYPES.SP_DETAIL:
        options = {
          date: sourceData.depDateTime, // 出发日期
          // 出发
          fromcitycode: sourceData.depCityCode,
          dcn: sourceData.depCityName,
          // 到达
          tocitycode: sourceData.arrCityCode,
          acn: sourceData.arrCityName,
          // 舱位
          cabin: 0,
        }
        break
      default:
        break;
    }
    goto({
      url,
      params: options
    })
  },
  async jumpTcUrl({ dispatch }, payload = {}) {
    if(payload?.type === FLIGHTS_URL_TYPES.SP_DETAIL) {
      dispatch('gotoFlightsPage', payload)
      return
    }
    dispatch('gotoFlightsPage', payload)
  },
  // 获取券列表
  async getFlightsCouponData({ commit }, options = {}) {
    try {
      const { code, data, success } = await getFlightCouponList(options)
      if (!success || code !== 200) return
      commit('setFlightsCouponData', handleFlightsCouponData(data))
    } catch (e) {
      console.log('请求券列表失败了! 主公！')
    }
  },
  async getQueryCardBtnText({ commit }) {
    const res = await getFlightsBannerText({
      position: 1,
      xenv: xenv()
    })
    if(res.code === 200) {
      commit('setQueryCardBtnText', res.data?.bannerInfos?.[0]?.resourceText)
    }
  }
}